// extracted by mini-css-extract-plugin
export default {"table":"Table_table__Lwsde","internalName":"Table_internalName__mDzry","icon":"Table_icon__i12+h","plus":"Table_plus__+bu6u"};